import styled from 'styled-components';
import {media} from "../../../../../theme";

export const SelectsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;

    ${media.tablet} {
        flex-direction: row;
        gap: 0;
        width: auto;
    }
`;
